import validator from 'validatorjs';

const validate = (): boolean => {
  return true;
};

validator.register('installments_card_brand', validate, 'installments_card_brand');
